export default {"src":"/_next/static/media/noti.da33e1f7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};